import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("button", {
      type: "button",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('clicked'))),
      class: _normalizeClass(["btn btn-brand1 btn-xs-w-100 px-5", _ctx.isDisabled ? 'disabled' : '']),
      disabled: _ctx.isDisabled ? true : false 
    }, _toDisplayString(_ctx.message), 11, _hoisted_1)
  ]))
}